import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/eeeFacultyData";

export const programme = {
  id: "eee-research",
  name: "Electrical & Electronics Engineering Research Centre",
  short: "EEE Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "2023-24",

  facultyData,
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The Department of Electrical and Electronics Engineering is recognized as a Research Centre from the academic year 2023-24 and offers Ph.D. and M.Sc. (Engineering) by Research programmes affiliated to Visvesvaraya Technological University (VTU), Belagavi. The faculty members are actively involved in research activities and have published research papers in reputed international journals while also presenting their work in national and international conferences and seminars.",

  image:
    "/HomePage/dept/eee.jpeg",

  labs: [
    "Research Computing Facility",
    "Power Systems Research Lab",
    "Electrical Machines Research Lab",
    "Control Systems Research Facility",
    "Simulation & Modelling Laboratory",
  ],

  dashboard: [
    ["Recognized Since", "2023-24"],
    ["Research Areas", "04+"],
    ["Research Supervisors", "01"],
    ["Research Scholars", "1"],
  ],

  quickFacts: [
    ["Established", "2023-24"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "02"],
    //["Research Scholars", "To be updated"],
    ["Research Areas", "Power Systems, Electrical Machines, Control Systems, Power Electronics"],
    ["Research Centre Area", "32 sq. m"],
    ["Total Investment", "₹6.31 Lakhs"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Objectives",
      text:"The Research and Development Cell promotes basic, strategic, and applied research to solve engineering challenges, encourages student and faculty research activities, supports project funding and publications, and facilitates knowledge creation through design, simulation, experimentation, analysis, and innovation.",
    },
    {
      title: "Research Facilities",
      text:
        "The department provides dedicated research infrastructure including advanced computing systems, simulation software and modern engineering tools to support doctoral research, project development and interdisciplinary innovation.",
    },
    {
      title: "Research Culture",
      text:
        "Faculty members actively contribute to research through publications in reputed journals, conference presentations, funded projects and collaborative academic activities. The centre encourages innovation, technical excellence and lifelong learning.",
    },
  ],

  curriculumSupport: [
    "Research methodology training",
    "Journal publication support",
    "Conference presentation guidance",
    "Project proposal preparation",
    "Simulation and modelling activities",
    "Prototype development",
    "Interdisciplinary research collaboration",
    "Ph.D. and M.Sc. (Engg.) research supervision",
  ],

  researchAreas: [
    "Power Systems",
    "Electrical Machines",
    "Control Systems",
    "Power Electronics",
  ],

  infrastructure: [
    ["Research Centre Area", "32 sq. m"],
    ["Total Investment", "₹6.31 Lakhs"],
    ["Computing Systems", "03 HP Pro PC 280-G9"],
    ["Processor", "Intel Core i7 (12th Generation)"],
    ["Memory", "16 GB DDR4 SDRAM"],
    ["Storage", "512 GB NVMe SSD"],
    ["Software Tools", "Keil, PSPICE, SCILAB, Octave"],
    ["Operating System", "Windows Pro 10 OEM"],
    ["Display", "19.5-inch LED Monitor"],
    ["Research Support", "Simulation, Design & Analysis"],
  ],

  infrastructureTable: {
    columns: ["Sl. No.", "Carpet Area (Sq.m)", "Major Equipment", "Quantity", "Investment (Lakhs)"],
    rows: [
      [
        "1",
        "32",
        "HP Pro PC 280-G9 Intel® CoreTM i7-12th Generation, 16 GB DDR4 SDRAM, 512GB NVMe SSD, Integrated Intel HD Graphics, Integrated Ethernet, 19.5 inch LED Monitor, Standard Keyboard and Mouse, Windows Pro 10 OEM Pack",
        "03",
        "6.31",
      ],
      ["", "", "Mi Power V9.1 Open source software: Keil, Pspice, SCILAB, Octave", "", ""],
    ],
  },

  achievements: [
    "Recognized as a VTU Research Centre in 2023-24.",
    "Offers Ph.D. and M.Sc. (Engineering) by Research programmes.",
    "Faculty members publish research papers in reputed international journals.",
    "Active participation in national and international conferences and seminars.",
    "",
  ],

  supervisors: [
    ["Dr. V. A. Kulkarni", "Professor & Principal", null, "/hero_images/VAKulkarni.jpg"],
    ["Mrs. V. P. Datar", "Research Scholar", null, "/FacultyCImages/V. P. Datar.png"],
  ],

  researchScholars: [],
};

const ResearchEEE = () => <ProgrammeDetail programme={programme} />;

export default ResearchEEE;
